module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-item-4-9051ca90b9c7c2a057ea4e2634698dc2.jpg";